import type { WorklistTableAddendum } from '../types';
import { WorklistItemStatus } from 'generated/graphql';

export const DraftTypeEnum = {
  REPORT: 'REPORT',
  ADDENDUM: 'ADDENDUM',
} as const;

export type DraftType = (typeof DraftTypeEnum)[keyof typeof DraftTypeEnum];

interface WorklistItemForDraftCheck {
  hasDraftReport?: Nullable<boolean>;
  status?: Nullable<WorklistItemStatus>;
  report?: Nullable<{
    sentAt?: Nullable<string | Date>;
    addendums?: ReadonlyArray<{
      smid: string;
      sentAt?: Nullable<string | Date>;
    }>;
  }>;
}

interface WorklistItemDraftState {
  draftType: DraftType | null;
  draftedAddendum: WorklistTableAddendum | undefined;
}

export const getWorklistItemDraftState = (
  worklistItem: Nullable<WorklistItemForDraftCheck>
): WorklistItemDraftState => {
  // As of 1/27/26 we don't reset hasDraftReport when a report is sent, so we need to check sentAt as well
  const hasDraftReport = worklistItem?.hasDraftReport === true && !worklistItem?.report?.sentAt;

  const draftedAddendum = worklistItem?.report?.addendums?.find((addendum) => !addendum.sentAt) as
    | WorklistTableAddendum
    | undefined;

  // Unified worklist fields omit report.addendums, but preserve the normalized addendum status.
  const hasDraftAddendum =
    worklistItem?.status === WorklistItemStatus.InProgressAddendum || draftedAddendum != null;

  let draftType: DraftType | null = null;
  if (hasDraftAddendum) {
    draftType = DraftTypeEnum.ADDENDUM;
  } else if (hasDraftReport) {
    draftType = DraftTypeEnum.REPORT;
  }

  return {
    draftType,
    draftedAddendum,
  };
};
